<template>
    <modal @modal-close="handleClose" size="half" tabindex="-1" role="dialog">
        <div class="bg-white rounded shadow-lg overflow-hidden pb-10 sm:pb-0">
            <div class="bg-light relative flex flex-wrap sm:flex-no-wrap sm:items-end sm:justify-between pt-8 pb-6 px-8">
                <button @click="handleClose" type="button" class="absolute top-0 right-0 text-gray-600 hover:text-gray-700 focus:outline-none mt-2 mr-4 py-1 px-2">
                    <i class="far fa-times fa-lg"></i>
                </button>

                <div class="w-full sm:w-auto text-center sm:text-left">
                    <h4 class="text-xl font-semibold mb-0">
                        <!-- <i class="fad fa-bell fa-lg mr-2"></i> -->
                        <i class="far fa-bell mr-2"></i>
                        Alert Settings
                    </h4>

                    <h5 class="text-base text-muted mb-0 mt-2 sm:mr-5">
                        {{ product.name }}
                    </h5>
                </div>

                <div class="mx-auto sm:mx-0 text-center sm:text-left">
                    <!-- @todo pause button -->
                    <follow-product-button :product="product" btn-class="btn-xs mt-4 sm:mt-0 text-xs sm:text-sm" subscribe-text="Follow Product" unsubscribe-text="Unfollow Product" />
                </div>
            </div>

            <table class="w-full table-auto bg-white border">
                <thead>
                    <tr class="hidden sm:table-row">
                        <th class="px-4 py-2 text-xs uppercase text-gray-700 font-semibold text-left" colspan="2">
                            Store
                        </th>
                        <th class="px-4 py-2 text-xs uppercase text-gray-700 font-semibold text-left">
                            Last Stock
                        </th>
                        <!-- <th class="px-4 py-2 text-xs uppercase text-gray-700 font-semibold text-left">
                            Last Alert
                        </th> -->
                        <th class="px-4 py-2">
                            <!-- Action -->
                            &nbsp;
                        </th>
                    </tr>
                </thead>
                <tbody class="rounded border-t" class2="border">
                    <tr v-for="listing in product.listings" :key="listing.id" class="transition duration-200 hover:bg-gray-100">
                        <td class="border-b pl-4 py-2 pr-4 sm:pr-2">
                            <div v-if="listing.store.image_url" class="store-avatar text-center mx-auto w-12 h-12">
                                <img :src="listing.store.image_url" :alt="listing.store.name" class="inline p-2 rounded-circle bg-white store-avatar-img" class2="w-12 h-12" />
                            </div>
                        </td>
                        <td class="border-b pr-4 py-2 text-left">
                            <div class="text-gray-700 font-semibold sm:whitespace-no-wrap">
                                {{ listing.store.name }}
                            </div>

                            <div class="text-muted text-xs">
                                {{ listing.name }}
                            </div>
                        </td>
                        <td class="border-b px-4 py-2 text-left text-xs text-gray-600 hidden sm:table-cell">
                            <span v-if="listing.stocked_at">
                                {{ dateTime2(listing.stocked_at) }}
                            </span>
                            <span v-else class="text-muted">
                                &ndash;
                            </span>
                        </td>
                        <td class="border-b px-4 py-2 text-right sm:text-center">
                            <follow-listing-button :listing="listing" btn-class="btn-xs" />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </modal>
</template>

<script>
export default {
    props: ['product'],

    data: () => ({}),

    created() {},

    mounted() {},

    computed: {},

    methods: {
        handleClose() {
            this.$emit('close');
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
